import Keycloak from 'keycloak-js'
import { apiServer } from '../setup-axios'
import { ssoUrl, ssoClientId } from '../config/env';

var keycloak = new Keycloak({
    url: ssoUrl,
    realm: 'main',
    clientId: ssoClientId,
    adapter: 'default',
})

function initKeycloak() {
    console.log('init keycloak');
    return keycloak.init({
        onLoad: 'check-sso',
        pkceMethod: 'S256',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: location.origin + "/silent-check-sso"
    })
    .then(authenticated => {
        console.log(`User is ${authenticated ? 'authenticated' : 'not authenticated'}`);
        if (authenticated) {
            setUserProfile();
        }
    })
    .catch(error => {
        console.error('Failed to initialize adapter:', error);
    });
}

async function login_keycloak() {
    console.log('login keycloak')
    console.log(keycloak)
    keycloak = new Keycloak({
        url: ssoUrl,
        realm: 'main',
        clientId: ssoClientId,
        adapter: 'default',
    })
    await initKeycloak().then(() => {
        return keycloak.login()
    });
}

function logout_keycloak() {
    keycloak.createLogoutUrl = function(options) {
        return keycloak.endpoints.logout()
            + '?client_id=' + ssoClientId
            + '&post_logout_redirect_uri=' + encodeURIComponent(window.location.href)
            + '&id_token_hint=' + JSON.parse(localStorage.getItem("keycloak")).idToken
    }
    return keycloak.logout()
}

function setUserProfile() {
    localStorage.setItem("snackbarText", "Login dengan SSO Berhasil. Anda akan segera masuk ke Sistem.")
    setUserDataKeycloak()
    apiServer
        .post("/login-keycloak")
        .then(response => {
            console.log(response)
            localStorage.setItem('user', JSON.stringify(response.data.data))
            localStorage.setItem('status', response.data.data.password_status)
            localStorage.setItem('accessTime', new Date())
            if (localStorage.getItem('currentPeran') === null) {
                console.log(response.data.data)
                localStorage.setItem('currentPeran', response.data.data.list_peran[0].kode_peran)
            }
            setKeycloakInterceptors()
        })
        .catch(error => {
            localStorage.setItem("snackbarText", error.response.data.message)
            console.log(error)
        })
}
function setUserDataKeycloak() {
    console.log("set data keycloak in localstorage")
    console.log(keycloak)
    console.log("set data tokenparsed keycloak in localstorage")
    console.log(keycloak.tokenParsed)
    localStorage.setItem('keycloak', JSON.stringify(keycloak))
    localStorage.setItem('token-type', "Keycloak")
    localStorage.setItem('keycloakLoggedIn', true)
    localStorage.setItem('keycloakToken', keycloak.token)
    console.log('keycloak.tokenParsed : ', getKeycloakData("tokenParsed"))
    // implement for keycloak: access token, refresh token.
    apiServer.defaults.headers.common.Authorization = `Bearer ${
        keycloak.token
    }`
    apiServer.defaults.headers.common['X-Token-Type'] = 'Keycloak'
    console.log("apiserver headers:")
    console.log(apiServer.defaults.headers.common)
    console.log('Token is set and is valid for '
                        + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds')
}

function setKeycloakInterceptors() {
    // Request interceptor for API calls
    apiServer.interceptors.request.use(
        async config => {
            try {
                const refreshed = await keycloak.updateToken(60);
                if (refreshed) {
                    console.log('Token is refreshed, valid for '
                        + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
                    setUserDataKeycloak();
                } else {
                    console.log('Token not refreshed, valid for '
                        + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
                }
            } catch (error) {
                console.log('Failed to refresh token');
                console.error(error);
            }
            config.headers = {
                'Authorization': `Bearer ${keycloak.token}`,
                'X-Token-Type': 'Keycloak'
            }
            return config;
        }
    );
}


function parsePeran(peran) {
    if (peran === 'admin') {
        return 'A01'
    } else if (peran === 'pengaju') {
        return 'A02'
    } else if (peran === 'penandatangan') {
        return 'A03'
    } else if (peran === 'auditor') {
        return 'A04'
    }
    return "Unknown"
}
// async function hitAPI() {
//     try {
//         await keycloak.updateToken(60)
//         const url = 'https://api.ui.ac.id/ldap/next/entry/imam'
//         const options = {
//             'credentials': 'include',
//             'headers': {
//                 'Authorization': 'Bearer ' + keycloak.token
//             }
//         }
//         const response = await fetch(url,options)
//         const output = await response.json()
//         console.log(output)
//     } catch (error) {
//         console.error('Failed to hit API:', error);
//     }  
// }

function getKeycloakData(dataKey) {
    return JSON.parse(localStorage.getItem('keycloak'))[dataKey]
  }

async function updateToken() {
    try {
      await keycloak.updateToken(60)
    } catch (error) {
      console.error('Failed to update token:', error)
    }
  }

export default keycloak
export{
    login_keycloak,
    logout_keycloak,
    updateToken,
    getKeycloakData,
    initKeycloak,
}